import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

const ProtectedRoute = () => {
    // Check if the user is authenticated
    const isLoggedIn = isAuthenticated();

    // If not authenticated, redirect to login
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // If authenticated, render the child routes
    return <Outlet />;
};

export default ProtectedRoute;